<!--Options-->
<div class="MainGrid2Col">
	<label>Student ID:</label>
	<label class="InfoText">{{ StudentID }}</label>

	<label>Student Name:</label>
	<label class="InfoText">{{ StudentName }}</label>

	<label>Meal Subsidy Assigned:</label>
	<label class="InfoText">{{ MealSubsidyDesc }}</label>

	<label>Meal Type:</label>
	<select class="form-control" [(ngModel)]="Meal" (ngModelChange)="onMealChange($event)">
		<option *ngFor="let r of lstMeal" [ngValue]="r">
			{{ r.MealName }}
		</option>
	</select>

	<label>Meal Subsidy:</label>
	<select class="form-control" [(ngModel)]="MealSubsidyType" (ngModelChange)="onMealSubsidyTypeChange($event)">
		<option *ngFor="let r of lstMealSubsidyType" [ngValue]="r">
			{{ r.MealSubsidyTypeDesc }}
		</option>
	</select>

	<label>Meal Date:</label>

	<label>Meal Time:</label>

	<label>Comments:</label>
	<textarea class="TextArea"></textarea>

	<label>Current Balance:</label>
	<label class="InfoText">{{ CurrentBalanceDesc }}</label>

	<label>Meal Cost (Before Subsidy):</label>
	<label class="InfoText">{{ MealPriceBeforeDesc }}</label>

	<label>Meal Cost (After Subsidy):</label>
	<label class="InfoText">{{ MealPriceAfterDesc }}</label>

	<label>Updated Balance:</label>
	<label class="InfoText">{{ NewBalance }}</label>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onAdd()">Add</button>
	<button class="btn btn-primary" (click)="onClose()">Cancel</button>
</div>
